import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  max-width: 1348px;
  margin: auto;
  padding: 0 20px;
`;

export default Container;
